<button #button class="m-btn" [ngClass]="{
    'm-btn-contained': display === 'contained',
    'm-btn-outlined': display === 'outlined',
    'm-btn-text': display === 'text',
    'm-btn-blue': color === 'blue',
    'm-btn-black': color === 'black',
    'm-btn-green': color === 'green',
    'm-btn-red': color === 'red',
    'm-btn-yellow': color === 'yellow',
    'm-btn-rounded': styles === 'rounded',
    'm-btn-stretch': size === 'stretch',
}" [disabled]="disabled" title="{{ title | translate }}" (mousedown)="onMouseDown($event)" [style.fontSize.px]="fontSize">
    @if (icon) {
    <i class="{{ icon }}"></i>
    }
    @if (label) {
        <span  class="label" [ngClass]="{'hide-text': animate === 'hide-text'}">{{ label | translate }}</span>
    }
    <span class="splash"></span>
</button>